var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v("\n    "+_vm._s(_vm.item.name)+"\n  ")]),_c('td',[_vm._v("\n    "+_vm._s(_vm.creationDate)+"\n  ")]),_c('td',[_c('login-personalize-list-item-actions',{attrs:{"item":_vm.item},on:{"deleted":_vm.emitDeleted}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }